/*!
 * Api, uses Axios Promise based HTTP client for the browser and node.js
 * Authors: ['Jorge Brunal Perez (aka Diniremix)', 'Duverney Ortiz']
 * Version: 2020-04-23
 * https://git.sitimapa.co/openroute/openroute-admin
 * Released under the MIT License.
 */

import axios from "axios";
import * as constants from "@/constants";
import store from "@/store";
import User from "@/models/User.js";

const defaultResposeError = (error) => {
	// Standarize errors.
	let errorMessage = null;
	if (error.response) {
		errorMessage = error.response.statusText || error.response.status;
	} else if (error.request) {
		errorMessage = "no response from server";
	} else {
		errorMessage = error.message;
	}
	return Promise.reject(new Error(errorMessage));
};

//Add a request interceptor
axios.interceptors.request.use(
	async (config) => {
		const usuario = new User();
		const token = await usuario.getToken();

		if (token !== null && token !== undefined) {
			config.headers = {
				...config.headers,
				Authorization: `Bearer ${token}`,
			};
			return config;
		}
		config.headers = {
			...config.headers,
			"Content-Type": "application/json",
		};
		return config;
	},
	(error) => {
		console.warn("Error: interceptors request use:", error);
		return Promise.reject(error);
	}
);

axios.interceptors.response.use(
	function (response) {
		return response;
	},
	function (error) {
		try {
			if ([715, 723].includes(error.response.data.status)) {
				store.dispatch("moduleCommon/logout");
			}
		} catch (error) {
			console.error("Error response api", error);
		}
		return Promise.reject(error);
	}
);
export default {
	get(url) {
		return axios
			.get(constants.API_BASE_URL + url)
			.then((response) => Promise.resolve(response.data))
			.catch(
				(defaultResposeError) =>
					new Promise((resolve, reject) => {
						if (defaultResposeError.hasOwnProperty("response")) {
							if (defaultResposeError.response.data.status === 722) {
								store.commit("setRequiredPermissions", defaultResposeError.response.data);
							}
							reject(defaultResposeError.response.data || {error: "error"});
						} else {
							// Se agrega esta validacion porque en el main se hace una peticion a los roles que retorna fail si el usuario
							// no se encuentra logueado
							if (url === "/role") return;
						}
					})
			);
	},

	post(url, data = {}) {
		return axios
			.post(constants.API_BASE_URL + url, data)
			.then((response) => Promise.resolve(response.data))
			.catch(
				(defaultResposeError) =>
					new Promise((resolve, reject) => {
						if (defaultResposeError.hasOwnProperty("response")) {
							if (defaultResposeError.response.data.status === 722) {
								store.commit("setRequiredPermissions", defaultResposeError.response.data);
							}
							reject(defaultResposeError.response.data);
						}
					})
			);
	},

	put(url, data = {}) {
		return axios
			.put(constants.API_BASE_URL + url, data)
			.then((response) => Promise.resolve(response.data))
			.catch(
				(defaultResposeError) =>
					new Promise((resolve, reject) => {
						if (defaultResposeError.hasOwnProperty("response")) {
							if (defaultResposeError.response.data.status === 722) {
								store.commit("setRequiredPermissions", defaultResposeError.response.data);
							}
							reject(defaultResposeError.response.data);
						}
					})
			);
	},

	delete(url) {
		return axios
			.delete(constants.API_BASE_URL + url)
			.then((response) => Promise.resolve(response.data))
			.catch(
				(defaultResposeError) =>
					new Promise((resolve, reject) => {
						if (defaultResposeError.hasOwnProperty("response")) {
							if (defaultResposeError.response.data.status === 722) {
								store.commit("setRequiredPermissions", defaultResposeError.response.data);
							}
							reject(defaultResposeError.response.data);
						}
					})
			);
	},
	upload(url, formData) {
		return axios
			.post(constants.API_BASE_URL + url, formData, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			})
			.then((response) => Promise.resolve(response.data))
			.catch(defaultResposeError);
	},
};
